import * as ActionType from "../actionType";
import { fetchContactPageApi } from "../../services/page/contact";

const getContactPageAction = () => {
  return async dispatch => {
    dispatchContactPage(dispatch);
  };
};

const dispatchContactPage = dispatch => {
  fetchContactPageApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_CONTACT_PAGE,
      data
    });
  });
};

export { getContactPageAction, dispatchContactPage };



// WEBPACK FOOTER //
// ./src/actions/page/contact.js